<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    @click="playAudio()"
  >
    <BaseSpriteIcon icon-name="ico-sound"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.play') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import GoogleAnalyticsUtils from '@/services/utils/GoogleAnalyticsUtils';
import PublicationLogicService from '@/services/PublicationLogic/PublicationLogicService';

export default {
  name: 'PlayAudioControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    }
  },
  methods: {
    async playAudio() {
      GoogleAnalyticsUtils.trackEvent('book', 'contextMenu', 'play');
      await PublicationLogicService.playAudioFromInTextRangeLocator(
        this.$store,
        this.$router,
        this.selectedLocator
      );
    }
  }
};
</script>
